<template>
  <div style="font-size:12px;">登陆跳转页面...</div>
</template>

<script>
import permissionApi from "@/api/api-permission";
export default {
  data () {
    return {
      loading: true
    };
  },
  methods: {
    // 临时模拟登陆
    handleLogin () {
      return new Promise((resolve, reject) => {
        permissionApi
          .loginTest2()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mounted () {
    this.handleLogin().then(
      res => {
        if (res != null) {
          this.$router.push({
            name: "shopSales"
          });
          this.loading = false;
        } else {
          this.loading = false;
          // 请检查账户和密码是否正确
        }
      },
      err => {
        this.loading = false;
        // "请检查账户和密码是否正确
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/view/login/login.vue